class CartRemoveButton extends HTMLElement {
    constructor() {
        super(),
            this.addEventListener("click", (t) => {
                t.preventDefault();
                (this.closest("cart-items") || this.closest("cart-drawer-items")).updateQuantity(this.dataset.index, 0);
            });
    }
}
customElements.define("cart-remove-button", CartRemoveButton);
class CartItems extends HTMLElement {
    constructor() {
        super(),
            (this.lineItemStatusElement =
                document.getElementById("shopping-cart-line-item-status") ||
                document.getElementById("CartDrawer-LineItemStatus"));
        const t = debounce((t) => {
            this.onChange(t);
        }, ON_CHANGE_DEBOUNCE_TIMER);
        this.addEventListener("change", t.bind(this));
    }
    cartUpdateUnsubscriber = void 0;
    connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (t) => {
            "cart-items" !== t.source && this.onCartUpdate();
        });
    }
    disconnectedCallback() {
        this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber();
    }
    resetQuantityInput(t) {
        const e = this.querySelector(`#Quantity-${t}`),
            r = this.querySelector(`#Drawer-quantity-${t}`);
        e && (e.value = e.getAttribute("value")), r && (r.value = r.getAttribute("value")), (this.isEnterPressed = !1);
    }
    setValidity(t, e, r) {
        t.target.setCustomValidity(r), t.target.reportValidity(), this.resetQuantityInput(e), t.target.select();
    }
    validateQuantity(t) {
        const e = parseInt(t.target.value),
            r = t.target.dataset.index;
        let a = "";
        0 === e
            ? (a = "")
            : e < t.target.dataset.min
              ? (a = window.quickOrderListStrings.min_error.replace("[min]", t.target.dataset.min))
              : e > parseInt(t.target.max)
                ? (a = window.quickOrderListStrings.max_error.replace("[max]", t.target.max))
                : e % parseInt(t.target.step) != 0 &&
                  (a = window.quickOrderListStrings.step_error.replace("[step]", t.target.step)),
            a
                ? this.setValidity(t, r, a)
                : (t.target.setCustomValidity(""),
                  t.target.reportValidity(),
                  this.updateQuantity(
                      r,
                      e,
                      document.activeElement.getAttribute("name"),
                      t.target.dataset.quantityVariantId
                  ));
    }
    onChange(t) {
        t.target.dataset.ignoreValidity || this.validateQuantity(t);
    }
    onCartUpdate() {
        "CART-DRAWER-ITEMS" === this.tagName
            ? fetch(`${routes.cart_url}?section_id=cart-drawer`)
                  .then((t) => t.text())
                  .then((t) => {
                      const e = new DOMParser().parseFromString(t, "text/html"),
                          r = ["cart-drawer-items", ".cart-drawer__footer"];
                      for (const t of r) {
                          const r = document.querySelector(t),
                              a = e.querySelector(t);
                          r && a && r.replaceWith(a);
                      }
                      publish(PUB_SUB_EVENTS.cartTotalRefreshed, {});
                  })
                  .catch((t) => {
                      console.error(t);
                  })
            : fetch(`${routes.cart_url}?section_id=cart-details`)
                  .then((t) => t.text())
                  .then((t) => {
                      const e = new DOMParser().parseFromString(t, "text/html").querySelector("cart-items");
                      this.innerHTML = e.innerHTML;
                  })
                  .catch((t) => {
                      console.error(t);
                  });
    }
    getSectionsToRender() {
        return [
            { id: "main-cart-items", section: "cart-details", selector: "#main-cart-items" },
            { id: "cart-icon-bubble", section: "cart-icon-bubble", selector: ".shopify-section" },
            { id: "cart-live-region-text", section: "cart-live-region-text", selector: ".shopify-section" },
        ];
    }
    updateQuantity(t, e, r, a) {
        this.enableLoading(t);
        const s = JSON.stringify({
            line: t,
            quantity: e,
            sections: this.getSectionsToRender().map((t) => t.section),
            sections_url: window.location.pathname,
        });
        fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body: s })
            .then((t) => t.text())
            .then((e) => {
                const s = JSON.parse(e),
                    n = document.getElementById(`Quantity-${t}`) || document.getElementById(`Drawer-quantity-${t}`),
                    i = document.querySelectorAll(".cart-item");
                if (s.errors) return (n.value = n.getAttribute("value")), void this.updateLiveRegions(t, s.errors);
                this.classList.toggle("is-empty", 0 === s.item_count);
                const c = document.querySelector("cart-drawer"),
                    o = document.getElementById("main-cart-footer");
                o && o.classList.toggle("is-empty", 0 === s.item_count),
                    c && c.classList.toggle("is-empty", 0 === s.item_count),
                    document.querySelector("body").classList.toggle("empty-cart", 0 === s.item_count),
                    this.getSectionsToRender().forEach((t) => {
                        (
                            document.getElementById(t.id).querySelector(t.selector) || document.getElementById(t.id)
                        ).innerHTML = this.getSectionInnerHTML(s.sections[t.section], t.selector);
                    });
                const d = s.items[t - 1] ? s.items[t - 1].quantity : void 0;
                let l = "";
                i.length === s.items.length &&
                    d !== parseInt(n.value) &&
                    (l =
                        void 0 === d
                            ? window.cartStrings.error
                            : window.cartStrings.quantityError.replace("[quantity]", d)),
                    this.updateLiveRegions(t, l);
                const u = document.getElementById(`CartItem-${t}`) || document.getElementById(`CartDrawer-Item-${t}`);
                u && u.querySelector(`[name="${r}"]`)
                    ? c
                        ? trapFocus(c, u.querySelector(`[name="${r}"]`))
                        : u.querySelector(`[name="${r}"]`).focus()
                    : 0 === s.item_count && c
                      ? trapFocus(c.querySelector(".drawer__inner-empty"), c.querySelector("a"))
                      : document.querySelector(".cart-item") &&
                        c &&
                        trapFocus(c, document.querySelector(".cart-item__name")),
                    publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items", cartData: s, variantId: a });
            })
            .catch(() => {
                this.querySelectorAll(".loading__spinner").forEach((t) => t.classList.add("hidden"));
                (
                    document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors")
                ).textContent = window.cartStrings.error;
            })
            .finally(() => {
                this.disableLoading(t);
            });
    }
    updateLiveRegions(t, e) {
        const r =
            document.getElementById(`Line-item-error-${t}`) || document.getElementById(`CartDrawer-LineItemError-${t}`);
        r && (r.querySelector(".cart-item__error-text").textContent = e),
            this.lineItemStatusElement.setAttribute("aria-hidden", !0);
        const a =
            document.getElementById("cart-live-region-text") || document.getElementById("CartDrawer-LiveRegionText");
        a.setAttribute("aria-hidden", !1),
            setTimeout(() => {
                a.setAttribute("aria-hidden", !0);
            }, 1e3);
        setTimeout(() => {
            try {
                const cartEmpty = document.querySelector('cart-drawer.is-empty');
                const cartGoal = document.querySelector('.product__info-wrapper dtc-goals-bar');
                if(cartGoal){
                    const mainCartGoal = document.querySelector('cart-drawer dtc-goals-bar');
                    if(!cartEmpty){
                        cartGoal.innerHTML = mainCartGoal.innerHTML
                    }else{
                        console.log('Cart empty');

                    }
                }
            } catch (error) {
                console.log('Cart goals not found!');
            }
        }, 1300);
    }
    getSectionInnerHTML(t, e) {
        return new DOMParser().parseFromString(t, "text/html").querySelector(e).innerHTML;
    }
    enableLoading(t) {
        (document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems")).classList.add(
            "cart__items--disabled"
        );
        [
            ...this.querySelectorAll(`#CartItem-${t} .loading__spinner`),
            ...this.querySelectorAll(`#CartDrawer-Item-${t} .loading__spinner`),
        ].forEach((t) => t.classList.remove("hidden")),
            document.activeElement.blur(),
            this.lineItemStatusElement.setAttribute("aria-hidden", !1);
    }
    disableLoading(t) {
        (
            document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems")
        ).classList.remove("cart__items--disabled");
        const e = this.querySelectorAll(`#CartItem-${t} .loading__spinner`),
            r = this.querySelectorAll(`#CartDrawer-Item-${t} .loading__spinner`);
        e.forEach((t) => t.classList.add("hidden")), r.forEach((t) => t.classList.add("hidden"));
    }
}
customElements.define("cart-items", CartItems),
    customElements.get("cart-note") ||
        customElements.define(
            "cart-note",
            class extends HTMLElement {
                constructor() {
                    super(),
                        this.addEventListener(
                            "input",
                            debounce((t) => {
                                const e = JSON.stringify({ note: t.target.value });
                                fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body: e });
                            }, ON_CHANGE_DEBOUNCE_TIMER)
                        );
                }
            }
        ),
    customElements.get("cart-blocks") ||
        customElements.define(
            "cart-blocks",
            class extends HTMLElement {
                constructor() {
                    super(), (this.block = this.querySelector(".cart-blocks"));
                }
                connectedCallback() {
                    const t = this.block;
                    setTimeout(function () {
                        t?.classList.add("loaded");
                    }, 1e3);
                }
            }
        );
class CartDetails extends HTMLElement {
    constructor() {
        super(), (this.sectionName = this.dataset.sectionName), (this.container = this);
    }
    connectedCallback() {
        this.sectionName && (this.fetchData(), this.setupCartSubscribe());
    }
    filterHTML(t) {
        const e = new DOMParser().parseFromString(t, "text/html");
        if (
            (e.querySelector("cart-drawer")?.classList.remove("drawer"), e.querySelector("dbtfy-shipping-calculator"))
        ) {
            ["data-province-wrapper", "data-country-id", "data-province-id"].forEach((t) => {
                const r = e.querySelector("dbtfy-shipping-calculator").getAttribute(t);
                (e.querySelector(`#${r}`).id = `${r}-page`),
                    e.querySelector("dbtfy-shipping-calculator").setAttribute(t, `${r}-page`);
            });
        }
        e.querySelector("agree-to-terms-page") &&
            ((e.querySelector("#agree-to-terms-page-checkbox-cart-drawer").id =
                "agree-to-terms-page-checkbox-cart-drawer-page"),
            e
                .querySelector('label[for="agree-to-terms-page-checkbox-cart-drawer"]')
                .setAttribute("for", "agree-to-terms-page-checkbox-cart-drawer-page"));
        e.querySelectorAll("[data-pageClasses]").forEach((t) => {
            const e = t.getAttribute("data-pageClasses");
            e && t.classList.add(...e.split(" "));
        });
        const r = e.querySelector("#CartDrawer");
        return r && ((r.className = ""), r.classList.add("cart-drawer")), e;
    }
    fetchData() {
        const t = `${routes.cart_url}?section_id=${this.sectionName}`;
        this.container.classList.contains("loaded") ||
            fetch(t)
                .then((t) => t.text())
                .then((t) => {
                    const e = this.filterHTML(t);
                    (this.container.innerHTML = ""),
                        this.container.appendChild(e.querySelector("#shopify-section-cart-drawer")),
                        this.container.classList.add("loaded");
                })
                .catch((t) => {
                    console.error("Fetch error:", t);
                });
    }
    setupCartSubscribe() {
        const t = this;
        document.addEventListener("DOMContentLoaded", function () {
            subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
                const r = e.cartData?.sections,
                    a = r && void 0 !== r["cart-drawer"] ? r["cart-drawer"] : null;
                if (a) {
                    const e = t.filterHTML(a);
                    (t.container.innerHTML = ""),
                        t.container.appendChild(e.querySelector("#shopify-section-cart-drawer"));
                }
            });
        });
    }
    updateSection(t) {
        const e = this.filterHTML(t);
        (this.container.innerHTML = ""), this.container.appendChild(e.querySelector("#shopify-section-cart-drawer"));
    }
}
customElements.define("cart-details", CartDetails);
